// eslint-disable-next-line import/prefer-default-export
export const IS_USER_AGENT_WITH_AVAILABLE_APP = (
  /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent)
);
